import { useEffect } from "react";

import { POWERBI_DASHBOARD_REPORT_TOKEN } from "../../appConstants";
import { appInsights } from "../../config/appInsights";

const GeneralPowerBiDashboard = () => {
  useEffect(() => {
    appInsights.trackPageView({
      name: "General Dashboard - (GeneralPowerBiDashboard.js)",
      isLoggedIn: true,
    });
  }, []);

  return (
    <div className="speed-1x fadeInRight">
      <iframe
        style={{ width: "100%", height: "100vh" }}
        title="Admin General Dashboard Report"
        allow="fullscreen"
        src={`https://app.powerbi.com/view?r=${POWERBI_DASHBOARD_REPORT_TOKEN}`}
      ></iframe>
    </div>
  );
};

export default GeneralPowerBiDashboard;
